import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reset-password-auth',
    templateUrl: './reset-password-auth.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class ResetPasswordAuthComponent implements OnInit {

  // showConfPassword: boolean;
  // showPassword: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
